import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { PortalAuthService } from './../../../shared/portal-auth/portal-auth.service';
import { NotificationService } from './../../../shared/notification/notification.service';
import { Component, OnInit, Input } from '@angular/core';
import { DialogService } from './../../../shared/dialog/dialog.service';
import { TranslationService } from './../../../shared/translation/translation.service';
import { ProfileRead } from '../../shared/profile-read.model';
import { ProfileService } from '../../shared/profile.service';
import { CustomerUserSearchDto } from 'src/app/shared/portal-auth/dto/customer-user-search.dto';
import { ConfigService } from 'src/app/config/shared/config.service';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';
import { AuthService } from 'src/app/shared';
import { BetaFeatureToggleEnum } from 'src/app/config/shared/constants/beta-feature-toggle.enum';

@Component({
  selector: 'wl-profile-edit-web-portal-credentials',
  templateUrl: './profile-edit-web-portal-credentials.component.html',
  styleUrls: ['./profile-edit-web-portal-credentials.component.css'],
  standalone: false
})
export class ProfileEditWebPortalCredentialsComponent implements OnInit {
  @Input()
  set profile(newProfile: ProfileRead) {
    if (newProfile.Inactive === null) {
      newProfile.Inactive = false;
    }
    if (newProfile.DisablePortalLogin === null || newProfile.DisablePortalLogin === undefined) {
      newProfile.DisablePortalLogin = false;
    }
    this._profile = newProfile;
    this.setupPortalData();
  }
  get profile() {
    return this._profile;
  }

  changingCredentials = false;
  originalUserName: string;
  passwordValue: string;
  changeButtonText: string;
  isUsingSystemCredentials = false;
  portalUsername: string;
  profilePortalUrl: string;
  private _profile: ProfileRead;
  private _passwordPlaceholder = '**************************';
  private _changeCredentialsText: string;
  private _cancelChangeText: string;

  constructor(
    private _profileService: ProfileService,
    private _portalAuthService: PortalAuthService,
    private _translationService: TranslationService,
    private _dialogService: DialogService,
    private _notifyService: NotificationService,
    private _navigationService: NavigationService,
    private _configService: ConfigService,
    private _authService: AuthService,
    private _configApiService: ConfigServiceService
  ) {}

  ngOnInit() {
    this._translationService.getTitlecase('profiles.edit.web-portal-credentials.change-credentials').then((value: string) => {
      this._changeCredentialsText = value;
      this.changeButtonText = this._changeCredentialsText;
    });
    this._translationService.getTitlecase('profiles.edit.web-portal-credentials.cancel-change').then((value: string) => {
      this._cancelChangeText = value;
    });
    this.passwordValue = this._passwordPlaceholder;
  }

  get passwordFieldType() {
    return this.changingCredentials ? 'password' : 'text';
  }

  onChangeCredentialsClick() {
    this.changingCredentials = !this.changingCredentials;
    if (this.changingCredentials) {
      this.originalUserName = this.portalUsername;
      this.passwordValue = '';
      this.changeButtonText = this._cancelChangeText;
    } else {
      this.portalUsername = this.originalUserName;
      this.passwordValue = this._passwordPlaceholder;
      this.changeButtonText = this._changeCredentialsText;
      this.isUsingSystemCredentials = false;
    }
  }

  onUseSystemCredentialsChange() {
    this.isUsingSystemCredentials = !this.isUsingSystemCredentials;
    if (this.isUsingSystemCredentials) {
      this.portalUsername = this.profile.Email;
      this.passwordValue = this.profile.ProfileId.toString();
    } else {
      this.portalUsername = this.originalUserName;
      this.passwordValue = '';
    }
  }

  onSendResetEmailClick() {
    const confirmMessage = this._translationService.getInstant('profiles.edit.web-portal-credentials.confirm-password-reset-send');
    const successMessage = this._translationService.getInstant('profiles.edit.web-portal-credentials.email-success');
    const failureMessage = this._translationService.getInstant('profiles.edit.web-portal-credentials.email-failure');
    this._dialogService.confirmYesNo(
      confirmMessage,
      () => {
        this._profileService.sendPortalPasswordResetEmail(this.profile.Email).then(
          () => this._notifyService.success(successMessage),
          () => this._notifyService.error(failureMessage)
        );
      },
      () => {}
    );
  }

  setPortalPasswordOnProfile() {
    // Since this component operates on the Profile object,
    // the API call to save happens in the ProfileEditComponent
    if (this.profile && this.changingCredentials && this.passwordValue !== '') {
      this.profile.UserName = this.portalUsername;
      this.profile.Password = this.passwordValue;
    }
  }

  async navigateToProfilePortal(): Promise<void> {
    const hasMemberPortalToggle = await this._configService.hasBetaFeatureEnabled(BetaFeatureToggleEnum.MemberPortal);
    const webComponentSettings = await this._configApiService.getWebComponentSettings('');

    if (hasMemberPortalToggle || webComponentSettings.RedirectLegacyToNew) {
      const portalUrl = this._authService.getPortalUrlWithAccessTokenHash(`/atlas/portal/profile/${this.profile.ProfileId}`);
      this._navigationService.popupSafeNavigate(portalUrl);
    } else {
      this._navigationService.navigateToProfileWebPortal(this.profile.ProfileId);
    }
  }

  private setupPortalData() {
    if (this.profile.ProfileId) {
      const dto = {
        TenantProfileId: this.profile.ProfileId,
      } as CustomerUserSearchDto;
      this._portalAuthService.searchPortalUsers(dto).then((data) => {
        if (data.Result.length > 0) {
          this.portalUsername = data.Result[0].Username;
        }
      });
    }
  }
}
